import { useState } from "react";
import { C } from "../../shared/theme";
import { findTheory, strategiesForReasons, KIND } from "./theories";
import { feelingTalkMessage } from "./learnContent";
import { kindHue, sectionLabel, pageTitle, intro, card, resetButton } from "./learnStyles";
import { TheoryRow, PutItToWork } from "./TheoryList";

// The strategies shown before "Show more": enough to choose from without a wall of rows.
export const STRATEGIES_SHOWN = 6;

// One feeling from "I'm stuck right now": the likeliest reasons behind it, then every
// strategy the reference doc links to those reasons, best first, then a way to act.
export function FeelingPage({ feeling, onOpen, onToday, onTalk }) {
  const [showAll, setShowAll] = useState(false);
  const reasons = feeling.reasons.map(n => findTheory(KIND.PROBLEM, n));
  const strategies = strategiesForReasons(feeling.reasons);
  const hidden = strategies.length - STRATEGIES_SHOWN;
  const shown = showAll || hidden <= 0 ? strategies : strategies.slice(0, STRATEGIES_SHOWN);

  const section = (kind, title, theories, after) => (
    <section style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <h2 style={{ ...sectionLabel(kindHue(kind).c), margin: "8px 0 0" }}>{title}</h2>
      <div style={card()}>
        {theories.map(t => <TheoryRow key={t.n} kind={kind} theory={t} onOpen={onOpen} quietNumber />)}
        {after}
      </div>
    </section>
  );
  return (
    <div style={{ padding: "4px 20px 28px", display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={sectionLabel(C.textMid)}>I'm stuck right now</div>
      <h1 tabIndex={-1} style={{ ...pageTitle, color: C.text, outline: "none" }}>{feeling.label}</h1>
      <p style={intro()}>The likeliest reasons come first. Open any one to read more. Below them are the things that help.</p>
      {section(KIND.PROBLEM, "What might be going on", reasons)}
      {section(KIND.SOLUTION, "What can help", shown, hidden > 0 && (
        <button onClick={() => setShowAll(s => !s)} aria-expanded={showAll}
          style={{ ...resetButton, width: "100%", minHeight: 48, padding: "0 14px", fontSize: 15, fontWeight: 700, color: kindHue(KIND.SOLUTION).c }}>
          {showAll ? "Show fewer" : hidden === 1 ? "Show 1 more thing that helps" : `Show ${hidden} more things that help`}
        </button>
      ))}
      <PutItToWork onToday={feeling.hideToday ? null : onToday} onTalk={() => onTalk(feelingTalkMessage(feeling))} />
    </div>
  );
}
